import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { all_information, loadingShow } from '../../../App';
import {
  AddSecurityRoles,
  DeleteSecurityRoles,
  EditSecurityRoles,
  getSecurityRoles,
} from '../../../services/SecurityRoles/SecurityRoles';

import Message from '../../../utils/Message/Message';

import './security.css';
import { getComponentS } from '../../../services/Components/ComponentServices';
import { getCompany } from '../../../services/Company/CompanyServices';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  securityRoleData: any;
  visibleDeleteDialog: boolean;
  companyData: any;
  Company: any;
  assignmentSecurityRolesData: any;
  AssignmentComponents: any;
}
interface IProps {
  GridHeight?: any;
}
export class SecurityRoles extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private buttonForAdd: ButtonPropsModel[];
  private role_code: string = '';
  private description: string = '';
  private status: boolean = false;
  private isAdmin: boolean = false;
  private buttonsDelete: ButtonPropsModel[];
  private roleId: number = -1;
  private isAdd: boolean = true;
  private title: string = '';
  private allComponentData = [];
  constructor(props: IProps) {
    super(props);
    this.getAllModules();
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      securityRoleData: [],
      visibleDeleteDialog: false,
      companyData: [],
      Company: '',
      assignmentSecurityRolesData: [],
      AssignmentComponents: [],
    };
    this.buttonForAdd = [
      {
        click: () => {
          this.addSite();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleAddDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteSites();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleDeleteDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteSites() {
    const obj = {
      role_id: this.roleId,
    };
    DeleteSecurityRoles(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getSecurityRoles();
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addSite() {
    loadingShow(true, 'Adding');
    if (this.state.Company === '') {
      Message.error('Company cannot be empty');
      loadingShow(false);
      return;
    }
    if (this.role_code === '') {
      Message.error('Security role cannot be empty');
      loadingShow(false);
      return;
    }
    if (this.description === '') {
      Message.error('Description cannot be empty');
      loadingShow(false);
      return;
    }
    let components = '';
    this.state.AssignmentComponents.map((el: any) => {
      components += el + ',';
    });
    const obj: any = {
      status: this.status,
      isAdmin: this.isAdmin,
      description: this.description,
      role_id: this.roleId,
      role_code: this.role_code,
      organization_id: this.state.Company,
      assigned_module: components,
      app: 'UWORK',
      created_by: all_information.user_id,
    };

    if (this.isAdd) {
      delete obj.role_id;
      AddSecurityRoles(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getSecurityRoles();
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditSecurityRoles(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getSecurityRoles();
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getSecurityRoles();
    this.getCompany();
    this.getAllModules();
  }

  getCompany() {
    getCompany()
      .then((el) => {
        this.setState({ companyData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getSecurityRoles() {
    getSecurityRoles()
      .then((el) => {
        this.setState({ securityRoleData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  async toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.role_code = '';
      this.description = '';
      this.isAdd = true;
      this.roleId = -1;
      this.status = false;
      this.isAdmin = false;
      this.title = 'Role Setup';
      this.setState({
        visibleAddDialog: true,
        Company: '',
        AssignmentComponents: [],
      });
    }
    if (args.item.id === 'delete') {
      if (this.securityRoleGrid.getSelectedRecords()) {
        if (this.securityRoleGrid.getSelectedRecords().length > 0) {
          var selectedElement =
            this.securityRoleGrid.getSelectedRecords() as any;
          this.roleId = selectedElement[0].role_id;
          this.setState({ visibleDeleteDialog: true });
        }
      }
    }
    if (args.item.id === 'edit') {
      if (this.securityRoleGrid.getSelectedRecords()) {
        if (this.securityRoleGrid.getSelectedRecords().length > 0) {
          this.isAdd = false;
          var selectedElement =
            this.securityRoleGrid.getSelectedRecords() as any;
          let theRoles = selectedElement[0].assigned_module.split(',');
          let tempCoponents: Array<any> = [];
          theRoles.map((el: any) => {
            if (el !== '') {
              tempCoponents.push(Number(el));
            }
          });
          this.role_code = selectedElement[0].role_code;
          this.description = selectedElement[0].description;
          this.roleId = selectedElement[0].role_id;
          this.status = selectedElement[0].status;
          var POID = Number(selectedElement[0].organization_id);
          await this.filterModules(POID);
          this.title = 'Edit Security Role';

          this.setState({
            visibleAddDialog: true,
            Company: POID,
            AssignmentComponents: tempCoponents,
          });
        }
      }
    }
    if (args.item.id === 'refresh') {
      this.getSecurityRoles();
    }
    if (this.securityRoleGrid && args.item.id === 'gridSecurity_excelexport') {
      this.securityRoleGrid.excelExport();
    }
  }

  disabledTemplate(e: any) {
    return (
      <div>
        {e.status ? (
          <div
            style={{
              backgroundColor: '#00A17A',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ACTIVE
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            INACTIVE
          </div>
        )}
      </div>
    );
  }
  adminTemplate(e: any) {
    return (
      <div>
        {e.isAdmin ? (
          <div
            style={{
              backgroundColor: '#00A17A',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ACTIVE
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            INACTIVE
          </div>
        )}
      </div>
    );
  }

  async filterModules(company_id: any) {
    await getComponentS(company_id)
      .then((el) => {
        this.setState({ assignmentSecurityRolesData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  async getAllModules() {
    await getComponentS()
      .then((el) => {
        this.setState({ assignmentSecurityRolesData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  ModuleTemplate(modules: any) {
    const ids = modules.assigned_module.split(',');
    var names: Array<any> = [];
    ids.map((el: any) => {
      if (el !== '') {
        const theElement = this.state.assignmentSecurityRolesData.filter(
          (com: any) => {
            return com.ID === Number(el);
          }
        ) as any;
        names.push(theElement[0]?.component_name);
      }
    });
    return (
      <div key={Math.random() + 'names' + names}>
        {names ? (
          names.map((el) => {
            return (
              <div
                key={Math.random() + 'names' + names + '2'}
                style={{ marginTop: 10 }}
              >
                {el}
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridSecurity'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.securityRoleData}
          height='calc(-220px + 100vh)'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='organization_code'
              headerText='Company Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='role_code'
              headerText='Role Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
            />
            <ColumnDirective
              field='assigned_module'
              headerText='Assigned Modules'
              textAlign='Left'
              template={this.ModuleTemplate.bind(this)}
            />

            <ColumnDirective
              field='status'
              headerText='Status'
              textAlign='Left'
              template={this.disabledTemplate.bind(this)}
              width={50}
            />
            <ColumnDirective
              field='isAdmin'
              headerText='Admin'
              textAlign='Left'
              template={this.adminTemplate.bind(this)}
              width={50}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
        {this.state.visibleAddDialog ? (
          <DialogComponent
            animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
            visible={this.state.visibleAddDialog}
            header={this.title}
            close={() => {
              this.setState({ visibleAddDialog: false });
            }}
            open={() => {
              this.setState({ visibleAddDialog: true });
            }}
            buttons={this.buttonForAdd}
            isModal
            showCloseIcon
            width={'500px'}
          >
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='col-md-12'>
                    <DropDownListComponent
                      id='orgCodeCompany'
                      placeholder='Company'
                      popupHeight={'auto'}
                      floatLabelType='Auto'
                      fields={{
                        text: 'organization_code',
                        value: 'organization_id',
                      }}
                      dataSource={this.state.companyData}
                      dataBound={() => {
                        //('Data integrated');
                      }}
                      value={this.state.Company}
                      onFocus={() => {
                        this.getCompany();
                      }}
                      onChange={(e: any) => {
                        this.filterModules(e.value);
                        this.setState({
                          Company: e.value,
                          AssignmentComponents: [],
                        });
                      }}
                    />
                  </div>
                  <div className='col-md-12'>
                    <TextBoxComponent
                      placeholder='Role Name'
                      floatLabelType='Auto'
                      value={this.role_code}
                      onChange={(el: any) => {
                        this.role_code = el.value;
                      }}
                    />
                  </div>

                  <div className='col-md-12'>
                    <TextBoxComponent
                      placeholder='Description'
                      floatLabelType='Auto'
                      value={this.description}
                      onChange={(e: any) => {
                        this.description = e.value;
                      }}
                    />
                  </div>

                  <div className='col-md-12'>
                    <MultiSelectComponent
                      placeholder='Assigned Components'
                      floatLabelType='Auto'
                      value={this.state.AssignmentComponents}
                      dataSource={this.state.assignmentSecurityRolesData}
                      fields={{ text: 'component_name', value: 'ID' }}
                      onChange={(el: any) => {
                        this.setState({ AssignmentComponents: el.value });
                      }}
                    />
                  </div>

                  <div className='col-md-12' style={{ marginTop: 20 }}>
                    <div className='col-md-7'>Status</div>
                    <div className='col-md-5'>
                      <SwitchComponent
                        id='swichActiveOrInActive'
                        change={(e: any) => {
                          this.status = e.checked;
                        }}
                        checked={this.status}
                      />
                    </div>
                  </div>
                  <div className='col-md-12' style={{ marginTop: 20 }}>
                    <div className='col-md-7'>Admin</div>
                    <div className='col-md-5'>
                      <SwitchComponent
                        id='swichActiveOrInActive'
                        change={(e: any) => {
                          this.isAdmin = e.checked;
                        }}
                        checked={this.isAdmin}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogComponent>
        ) : null}

        {this.state.visibleDeleteDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            visible={this.state.visibleDeleteDialog}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={() => {
              this.setState({ visibleDeleteDialog: true });
            }}
            close={() => {
              this.setState({ visibleDeleteDialog: false });
            }}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
      </div>
    );
  }
}

export default SecurityRoles;
